<template :key="remount">
  <v-row class="d-flex justify-lg-space-between mb-2">
    <v-col cols="12" md="6" lg="4">
      <form class="d-flex align-center" @submit.prevent="handleSubmit">
        <v-text-field
          outlined
          dense
          label="Search by name"
          hide-details="auto"
          v-model="search"
        ></v-text-field>

        <v-btn type="submit" @click="handleSubmit">Search</v-btn>
      </form>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <div style="display: flex">
        <v-menu
          right
          content-class="SearchActionList"
          rounded="lg"
          :close-on-content-click="false"
          v-model="expanded"
          :attach="true"
        >
          <template v-slot:activator="{ attrs, on }">
            <div class="SearchActionList__plus-block">
              <div style="display: flex">
                <span style="margin-right: 10px; color: #6e6e6e">
                  Contains Actions
                </span>
              </div>
              <v-icon
                color="#374151"
                v-bind="attrs"
                v-on="on"
                class="SearchActionList__action"
              >
                mdi-plus
              </v-icon>
            </div>
          </template>

          <v-card
            class="SearchActionList__menu-list"
            max-width="280"
            max-height="365"
            rounded="lg"
          >
            <v-card-title>
              <v-text-field
                label="Search Actions"
                outlined
                dense
                :hide-details="true"
                v-model="connectorSearch"
              />
            </v-card-title>

            <v-card-text class="SearchActionList__menu-list">
              <v-list>
                <v-list-item-group
                  v-for="connector in connectors"
                  :key="connector.type_id"
                >
                  <template
                    v-if="
                      connector.name &&
                      connector.action_type !== 'internal_knowledge_action' &&
                      !isSelected(connector)
                    "
                  >
                    <template>
                      <v-list-item @click="selectedConnectors.push(connector)">
                        <ActionIcon :action="connector" />

                        <v-list-item-content two-line>
                          <v-list-item-title
                            class="SearchActionList__menu-title"
                          >
                            {{ connector.aiActionName || connector.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{
                              connector.descr || '** provide description plz **'
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-container>
          <v-row align="center" justify="start">
            <v-col
              v-for="(selection, i) in selectedConnectors"
              :key="selection.action_type + '_selected'"
              class="py-1 pe-0"
              cols="auto"
            >
              <v-chip
                @click="selectedConnectors.splice(i, 1)"
                closable
                style="box-shadow: 4px 4px 4px -4px rgba(34, 60, 80, 0.2)"
                color="white"
              >
                <ActionIcon :action="selection" :color="selection.color" />
              </v-chip>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-col>

    <v-col cols="1" class="d-flex align-content-end self-end">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :color="buttonColor"
            icon
            v-bind="attrs"
            v-on="on"
            @click="handleArchiveChange"
          >
            <v-icon>mdi-archive</v-icon>
          </v-btn>
        </template>
        <span class="toggle">Toggle Archive View</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import ActionIcon from '@/components/action-icon/action-icon.vue';
import { actionsTypes } from '@/util/action-types';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'WorkflowSearchForm',
  components: { ActionIcon },
  data() {
    return {
      remount: 0,
      expanded: false,
      search: '',
      showingArchived: false,
      connectorSearch: '',
      selectedConnectors: [],
      firstExpandClick: true,
    };
  },
  mounted() {
    this.search = this.$route.query.search ?? '';
    this.showingArchived = this.$route?.query?.archived === 'archived';
    if (this.$route?.query?.action_types) {
      const conntrs = this.connectors.filter((conn) =>
        this.$route?.query?.action_types.includes(conn.action_type),
      );
      this.selectedConnectors = conntrs;
    }
  },
  watch: {
    selectedConnectors(val) {
      this.$emit('filter-update', {
        search: this.search,
        archived: this.archived,
        action_types: val.map((act) => act.action_type),
      });
    },
  },
  computed: {
    archived() {
      return this.showingArchived ? 'archived' : 'active';
    },
    buttonColor() {
      return this.showingArchived ? '' : 'primary';
    },
    actionsTypes() {
      let at = actionsTypes();

      return cloneDeep(at).filter((action) => {
        return !(action.action_type === 'human_in_the_loop');
      });
    },
    connectors() {
      const actionsTypes = this.excludeAction(this.actionsTypes);
      if (!this.connectorSearch) {
        let plainActions = [];
        actionsTypes.map((act) => {
          if (act.actions) {
            plainActions = [...plainActions, ...act.actions];
            return;
          } else {
            plainActions.push(act);
          }
        });
        return plainActions;
      }
      const searchValue = this.connectorSearch.toLowerCase();
      const result = [];

      for (let i = 0; i < actionsTypes.length; i++) {
        const group = cloneDeep(actionsTypes[i]);
        if (
          group.name?.toLowerCase().includes(searchValue) ||
          group.display_name?.toLowerCase().includes(searchValue) ||
          group.action_type?.toLowerCase().includes(searchValue) ||
          group.descr?.toLowerCase().includes(searchValue)
        ) {
          result.push(group);
          continue;
        }

        if (group.actions) {
          const actions = group.actions;
          group.actions = [];

          actions.forEach((action) => {
            if (
              action.name?.toLowerCase().includes(searchValue) ||
              action.display_name?.toLowerCase().includes(searchValue) ||
              action.action_type?.toLowerCase().includes(searchValue) ||
              action.descr?.toLowerCase().includes(searchValue)
            ) {
              group.actions.push(action);
            }
          });

          if (group.actions.length > 0) {
            result.push(group);
          }
        }
      }
      let plainActions = [];
      result.map((act) => {
        if (act.actions) {
          plainActions = [...plainActions, ...act.actions];
          return;
        } else {
          plainActions.push(act);
        }
      });
      return plainActions;
    },
  },
  methods: {
    setExpand(val) {
      if (this.firstExpandClick && !val) {
        this.firstExpandClick = false;
        return;
      } else if (!this.firstExpandClick && !val) {
        this.firstExpandClick = true;
      }
      this.expanded = val;
    },
    isSelected(connector) {
      if (!this.selectedConnectors || this.selectedConnectors?.length === 0) {
        return false;
      }
      const selected = this.selectedConnectors.find(
        (slc) => slc.action_type === connector.action_type,
      );
      return !!selected;
    },
    excludeAction(actions) {
      return actions.filter((action) => {
        return !action.default;
      });
    },
    handleArchiveChange() {
      this.showingArchived = !this.showingArchived;
      this.handleSubmit();
    },
    handleSubmit() {
      this.$emit('filter-update', {
        search: this.search,
        archived: this.archived,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './automation.scss';
.toggle {
  width: fit-content;
}
.connector_container {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: white;
  position: absolute;
  z-index: 9999;
  min-height: 500px;
  width: 320px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.connector_list_select {
  overflow-y: auto;
  max-height: 500px;
  flex-wrap: wrap;
  position: absolute;
  z-index: 9999;
  width: 320px;
  display: flex;
}

.connector_group {
  display: flex;
  flex-wrap: wrap;
}

.close_btn {
  position: absolute;
  z-index: 9999 + 1;
}
</style>
